import usePlacesService from 'react-google-autocomplete/lib/usePlacesAutocompleteService';
import { env } from 'next-runtime-env';
import Select from 'react-select';
import { useState } from 'react';

type GooglePlacesAutocompleteProps = {
  onPlaceSelect: (placeData: any) => void;
};

const GooglePlacesAutocomplete = (props: GooglePlacesAutocompleteProps) => {
  const {
    placesService,
    placePredictions,
    getPlacePredictions,
    isPlacePredictionsLoading,
    autocompleteSessionToken,
  } = usePlacesService({
    apiKey: env('GOOGLE_PLACES_API'),
    sessionToken: true,
  });

  const [searchVal, setSearchVal] = useState<string>('');

  const handlePredictionClick = (item: any) => {
    placesService?.getDetails(
      {
        placeId: item.place_id,
        fields: ['geometry.viewport', 'formatted_address'],
        sessionToken: autocompleteSessionToken,
      },
      (placeResult: any, placesServiceStatus: string) => {
        if (placesServiceStatus === 'OK') {
          props.onPlaceSelect(placeResult);
        }
      }
    );
  };

  return (
    <div className='flex-grow'>
      <Select
        placeholder={'Enter location name'}
        options={placePredictions}
        getOptionLabel={(op) => op.description}
        getOptionValue={(op) => op.place_id}
        onChange={(value) => handlePredictionClick(value)}
        isLoading={isPlacePredictionsLoading}
        onInputChange={(newVal) => {
          setSearchVal(newVal);
          if (newVal.length > 0) getPlacePredictions({ input: newVal });
        }}
        inputValue={searchVal}
        menuPlacement={'top'}
      />
    </div>
  );
};

export default GooglePlacesAutocomplete;
